/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import PriceAndProcessorIds from './PriceAndProcessorIds';

/**
 * The AqaNewPlan model module.
 * @module model/AqaNewPlan
 * @version v0
 */
export default class AqaNewPlan {
  /**
   * Constructs a new <code>AqaNewPlan</code>.
   * @alias module:model/AqaNewPlan
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaNewPlan</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaNewPlan} obj Optional instance to populate.
   * @return {module:model/AqaNewPlan} The populated <code>AqaNewPlan</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaNewPlan();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('maxNumberOfUsers'))
        obj.maxNumberOfUsers = ApiClient.convertToType(data['maxNumberOfUsers'], 'Number');
      if (data.hasOwnProperty('productIdByPaymentProcessor'))
        obj.productIdByPaymentProcessor = ApiClient.convertToType(data['productIdByPaymentProcessor'], {'String': 'String'});
      if (data.hasOwnProperty('pricePerPeriodAndPerCurrency'))
        obj.pricePerPeriodAndPerCurrency = ApiClient.convertToType(data['pricePerPeriodAndPerCurrency'], {'String': {'String': PriceAndProcessorIds}});
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
AqaNewPlan.prototype.id = undefined;

/**
 * @member {String} name
 */
AqaNewPlan.prototype.name = undefined;

/**
 * @member {Number} maxNumberOfUsers
 */
AqaNewPlan.prototype.maxNumberOfUsers = undefined;

/**
 * @member {Object.<String, String>} productIdByPaymentProcessor
 */
AqaNewPlan.prototype.productIdByPaymentProcessor = undefined;

/**
 * @member {Object.<String, Object.<String, module:model/PriceAndProcessorIds>>} pricePerPeriodAndPerCurrency
 */
AqaNewPlan.prototype.pricePerPeriodAndPerCurrency = undefined;

